export const PAGE_VISIT_FRONTPAGE = 'SAWebPageFrontPage';
export const PAGE_VISIT_GETSTARTED = 'SAWebPageGetStarted';
export const CLICK_DOWNLOAD_LINK = 'SAWebLinkDownloadSuuntoApp';
export const PAGE_VISIT_PASSWORD_RESET = 'SAWebPageResetPassword';
export const PAGE_VISIT_ACCOUNT_DELETION = 'SAWebPageAccountDeletion';
export const PAGE_VISIT_WORKOUT_MOVE = 'SAWebPageWorkoutDetails';
export const CLICK_RECENT_ACTIVITY_LINK = 'SAWebRecentActivity';
export const CLICK_SOME_LINK = 'SAWebLinkSocialMedia';
export const SCROLL_WORKOUT_DETAILS = 'SAWebWorkoutScrollDetails';
export const SCROLL_WORKOUT_PHOTOS = 'SAWebWorkoutScrollPhotos';
export const TOGGLE_GRAPH_TYPE = 'SAWebWorkoutToggleGraphs';
export const TOGGLE_SPLITS = 'SAWebWorkoutToggleSplits';
export const CLICK_SUPPORT_LINK = 'SAWebLinkSupport';
export const CLICK_SUUNTOCOM_LINK = 'SAWebLinkSuunto';
export const CLICK_FORUM_LINK = 'SAWebLinkForums';
export const PASSWORD_RESET_USED = 'SAWebPasswordResetUsed';
export const PASSWORD_RESET_SUCCESS = 'SAWebPasswordResetSuccessful';
export const PASSWORD_RESET_ERROR = 'SAWebPasswordResetError';
export const ACCOUNT_DELETION_REQUEST_SUCCESS = 'SAWebAccountDeletionRequestSuccessful';
export const ACCOUNT_DELETION_REQUEST_ERROR = 'SAWebAccountDeletionRequestError';
export const MAP_SCROLLED = 'SAWebMapScroll';
export const MAP_ZOOMED = 'SAWebMapZoom';
export const SURVEY_CLICKED = 'SAWebSurvey';
